import { z } from "zod";
import { baseEntitySchema } from "./base";

// A daily snapshot of a Mercury account's balance, captured by the scheduled
// balance sync so balances can be tracked over time. Document id is
// `${accountId}_${date}` (one snapshot per account per day).
export const mercuryBalanceSnapshotDataSchema = z.object({
  accountId: z.string(),
  accountName: z.string().optional(),
  kind: z.string().optional(),
  availableBalance: z.number(),
  currentBalance: z.number(),
  currency: z.string().default("USD"),
  // "YYYY-MM-DD" (UTC).
  date: z.string(),
  capturedAt: z.date(),
});

export type MercuryBalanceSnapshotData = z.infer<
  typeof mercuryBalanceSnapshotDataSchema
>;
export const mercuryBalanceSnapshotSchema = baseEntitySchema.merge(
  mercuryBalanceSnapshotDataSchema,
);
export type MercuryBalanceSnapshot = z.infer<
  typeof mercuryBalanceSnapshotSchema
>;
